import axios from "axios";

axios.interceptors.request.use((config) => {
  // config.headers["app-id"] = "61c31b58b78391f2209599e7";
//   config.headers["Access-Control-Allow-Credentials"] = true
// config.headers["Access-Control-Allow-Headers"] = "Origin, Content-Type, Accept, Authorization, X-Request-With";
// config.headers["Access-Control-Allow-Methods"] = "GET, POST, PUT, DELETE, OPTIONS";
// config.headers["Access-Control-Allow-Origin"] = "*";
// config.headers["Access-Control-Max-Age"] = 600;
// config.headers["Cache-Control"] = "no-cache";
// config.headers["Content-Length"] = 2374
// config.headers["Content-Type"] = "text/plan";
// config.headers["Pragma"] = "no-cache";
// config.headers["Server"] = "Microsoft-IIS/10.0";
// config.headers["X-aspnet-version"] = "4.0.30319";
// config.headers["X-Powered-By"] = "ASP.NET";
  return config;
});

export const request = {
  get: axios.get,
};

export const requestPost = {
  post: axios.post,
};
